if(!window.Highcharts.maps) {
    window.Highcharts.maps = {};
    require('highcharts/modules/map')(window.Highcharts);
    require('./highmaps/highcharts_map_world');
    require('./highmaps/highcharts_map_us');
    require('./highmaps/highcharts_map_ar');
    require('./highmaps/highcharts_map_au');
    require('./highmaps/highcharts_map_br');
    require('./highmaps/highcharts_map_ca');
    require('./highmaps/highcharts_map_de');
    require('./highmaps/highcharts_map_fr');
    require('./highmaps/highcharts_map_africa');
    require('./highmaps/highcharts_map_asia');
    require('./highmaps/highcharts_map_central_america');
    require('./highmaps/highcharts_map_europe');
    require('./highmaps/highcharts_map_middle_east');
    require('./highmaps/highcharts_map_nordic_countries');
    require('./highmaps/highcharts_map_north_america');
    require('./highmaps/highcharts_map_oceania');
    require('./highmaps/highcharts_map_scandinavia');
    require('./highmaps/highcharts_map_south_america');
    require('./highmaps/highcharts_map_world_continents');
}